import { axiosInstance } from '../../config/axiosConfig';
import { AxiosError, AxiosResponse } from 'axios';
import { endPointUrls } from '../constants/endPoints';
import {
    ICountriesRepsonse,
    IRegionsRepsonse,
    ISubRegionsRepsonse,
    ITaxNameResponse,
    ICalcBasisResponse,
    IDescriptiveTextResponse,
    IInsurancePartiesResponse,
    ICoreTaxCreateRequest,
    ICoreTaxCreateResponse,
    ICoreTaxRateCreateRequest,
    ICoreTaxRateCreateResponse,
    ICoreTaxDetailsResponse,
    ICoreTaxUpdateRequest,
    ICoreTaxUpdateResponse,
} from '../types/rate.type';

const getCountries = (): Promise<ICountriesRepsonse> => {
    return axiosInstance
        .get(endPointUrls.getCountries)
        .then((res: AxiosResponse<ICountriesRepsonse>) => {
            return res.data;
        })
        .catch((error: AxiosError) => {
            throw error;
        });
};

const getRegions = (countryCodes: string[]): Promise<IRegionsRepsonse> => {
    return axiosInstance
        .get(endPointUrls.getRegions, { params: { countryCodes: countryCodes.join(',') } })
        .then((res: AxiosResponse<IRegionsRepsonse>) => {
            return res.data;
        })
        .catch((error: AxiosError) => {
            throw error;
        });
};

const getSubRegions = (regionIds: string[]): Promise<ISubRegionsRepsonse> => {
    return axiosInstance
        .get(endPointUrls.getSubRegions, { params: { regionIds: regionIds.join(',') } })
        .then((res: AxiosResponse<ISubRegionsRepsonse>) => {
            return res.data;
        })
        .catch((error: AxiosError) => {
            throw error;
        });
};

const getTaxNames = (): Promise<ITaxNameResponse> => {
    return axiosInstance
        .get(endPointUrls.getTaxName)
        .then((res: AxiosResponse<ITaxNameResponse>) => {
            return res.data;
        })
        .catch((error: AxiosError) => {
            throw error;
        });
};

const getCalcBasis = (): Promise<ICalcBasisResponse> => {
    return axiosInstance
        .get(endPointUrls.getCalcBasis)
        .then((res: AxiosResponse<ICalcBasisResponse>) => {
            return res.data;
        })
        .catch((error: AxiosError) => {
            throw error;
        });
};

const getDescriptiveTextResponse = (searchText: string, textType: string): Promise<IDescriptiveTextResponse> => {
    return axiosInstance
        .get(endPointUrls.getDescriptiveText, { params: { searchText: searchText, textType: textType } })
        .then((res: AxiosResponse<IDescriptiveTextResponse>) => {
            return res.data;
        })
        .catch((error: AxiosError) => {
            throw error;
        });
};

const getInsurancePartiesResponse = (): Promise<IInsurancePartiesResponse> => {
    return axiosInstance
        .get(endPointUrls.getInsuranceParties)
        .then((res: AxiosResponse<IInsurancePartiesResponse>) => {
            return res.data;
        })
        .catch((error: AxiosError) => {
            throw error;
        });
};

const saveCoreTaxes = (reqBody: ICoreTaxCreateRequest[]): Promise<ICoreTaxCreateResponse> => {
    return axiosInstance
        .post(endPointUrls.saveCoreTaxes, reqBody)
        .then((res: AxiosResponse<ICoreTaxCreateResponse>) => {
            return res.data;
        })
        .catch((error: AxiosError) => {
            throw error;
        });
};

const saveCoreTaxRates = (reqBody: ICoreTaxRateCreateRequest[]): Promise<ICoreTaxRateCreateResponse> => {
    return axiosInstance
        .post(endPointUrls.saveCoreTaxRates, reqBody)
        .then((res: AxiosResponse<ICoreTaxRateCreateResponse>) => {
            return res.data;
        })
        .catch((error: AxiosError) => {
            throw error;
        });
};

const getCoreTaxDetailsByID = (id: string): Promise<ICoreTaxDetailsResponse> => {
    return axiosInstance
        .get(endPointUrls.getCoreTaxDetailsByID + id)
        .then((res: AxiosResponse<ICoreTaxDetailsResponse>) => {
            return res.data;
        })
        .catch((error: AxiosError) => {
            throw error;
        });
};

const updateCoreTaxDetails = (reqBody: ICoreTaxUpdateRequest[]): Promise<ICoreTaxUpdateResponse> => {
    return axiosInstance
        .patch(endPointUrls.updateCoreTaxDetails, reqBody)
        .then((res: AxiosResponse<ICoreTaxUpdateResponse>) => {
            return res.data;
        })
        .catch((error: AxiosError) => {
            throw error;
        });
};

const coreTaxDetailsServices = {
    getCountries,
    getRegions,
    getSubRegions,
    getTaxNames,
    getCalcBasis,
    getDescriptiveTextResponse,
    getInsurancePartiesResponse,
    saveCoreTaxes,
    saveCoreTaxRates,
    getCoreTaxDetailsByID,
    updateCoreTaxDetails,
};

export default coreTaxDetailsServices;
